module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"wh100 table table-w-100-0\">\n	<div>\n		")
    ;  if (widget.gridTemplate) { 
    ; __append("\n			<div>\n				")
    ; __append( UI.Template.render(widget.gridTemplate, {widget: widget}) )
    ; __append("\n			</div>\n		")
    ;  } 
    ; __append("\n\n		<div name=\"data\" class=\"h100\" style=\"min-width: ")
    ; __append(escapeFn( widget.editorWidth ))
    ; __append(";\">\n			<div class=\"cell__abs_container\">\n				<div class=\"cell__abs\">\n					")
    ;  if (widget.editorTemplate) { 
    ; __append("\n						")
    ; __append( UI.Template.render(widget.editorTemplate, {widget: widget}) )
    ; __append("\n					")
    ;  } 
    ; __append("\n				</div>\n			</div>\n		</div>\n\n	</div>\n</div>\n")
  }
  return __output.join("");

}